<div class="container col-lg-12  pl-3">
    <!-- Titre -->

    <dd style="margin-bottom: 4px"><b>Document</b></dd>

    <div class="row mb-2" *ngIf="loadingSettings">
        <div class="col-12">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            <span class="ml-2 size13">Chargement des paramètres…</span>
        </div>
    </div>

    <!-- Modèles -->
    <div class="row mb-1" style="height: 215px;">
        <div class="card-model p-2 col-lg-2 col-xl-2 mt-2 mb-2 ml-0" [class.card-selected]="selectedDocModel === 1" (click)="selectedDocModel = 1">
            <p class="size15" style="color: #2F2B3DE5">Modèle 1</p>
            <div class="org-radio-wrapper">
                <input type="radio" name="refStatic" id="refStatic1" value="1" [checked]="selectedDocModel === 1" (change)="selectedDocModel = 1" class="org-radio-input">
                <label class="org-radio-label" for="refStatic1"><span class="org-radio-dot"></span></label>
            </div>
        </div>

        <div class="card-model p-2 col-lg-2 col-xl-2 m-2" [class.card-selected]="selectedDocModel === 2" (click)="selectedDocModel = 2">
            <p class="size15" style="color: #2F2B3DE5">Modèle 2</p>
            <div class="org-radio-wrapper">
                <input type="radio" name="refStatic" id="refStatic2" value="2" [checked]="selectedDocModel === 2" (change)="selectedDocModel = 2" class="org-radio-input">
                <label class="org-radio-label" for="refStatic2"><span class="org-radio-dot"></span></label>
            </div>
        </div>
    </div>

    <!-- Langue -->
    <div class="row mb-2">
        <div class="col-lg-4 p-0">
            <label class="size13">Langue du document</label>
            <select class="form-control" name="langueDocument" [(ngModel)]="selectedLangue">
                <option [ngValue]="'francais'">Français</option>
                <option [ngValue]="'anglais'">Anglais</option>
                <option [ngValue]="'arabe'">Arabe</option>
            </select>
        </div>
    </div>

    <!-- Génération bon de livraison -->
    <div class="row mb-1">
        <div class="d-flex flex-column gap-2">
            <label class="mb-0 size15">Activer la génération automatique d'un bon de livraison</label>
            <div class="d-flex flex-column gap-2" style="margin-top: 8px;">
                <div class="d-flex align-items-center gap-2">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="livraison" id="livraisonOui" value="oui" [(ngModel)]="selectedLivraison" (ngModelChange)="onLivraisonChange()" class="org-radio-input" [disabled]="savingActiveBonLiv || loadingSettings">
                        <label class="org-radio-label" for="livraisonOui"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" style="margin-left: 9px; cursor: pointer" for="livraisonOui">Oui</label>
                </div>
                <div class="d-flex align-items-center gap-2" style="margin-top: 8px">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="livraison" id="livraisonNon" value="non" [(ngModel)]="selectedLivraison" (ngModelChange)="onLivraisonChange()" class="org-radio-input" [disabled]="savingActiveBonLiv || loadingSettings">
                        <label class="org-radio-label" for="livraisonNon"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" style="margin-left: 9px; cursor: pointer" for="livraisonNon">Non</label>
                </div>
            </div>
        </div>
    </div>

    <!-- Mettre à jour le prix d'achat sur la fiche produit -->
    <div class="row mb-1">
        <div class="d-flex flex-column gap-2">
            <label class="mb-0 size15">Ajouter le prix d'achat dans le produit</label>
            <div class="d-flex flex-column gap-2" style="margin-top: 8px;">
                <div class="d-flex align-items-center gap-2">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="majPrixAchatProduit" id="majPrixAchatOui" value="oui" [(ngModel)]="selectedMajPrixAchatProduit" (ngModelChange)="onMajPrixAchatProduitChange()" class="org-radio-input" [disabled]="savingPrixAchatOpts || loadingSettings">
                        <label class="org-radio-label" for="majPrixAchatOui"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" style="margin-left: 9px; cursor: pointer" for="majPrixAchatOui">Oui</label>
                </div>
                <div class="d-flex align-items-center gap-2" style="margin-top: 8px">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="majPrixAchatProduit" id="majPrixAchatNon" value="non" [(ngModel)]="selectedMajPrixAchatProduit" (ngModelChange)="onMajPrixAchatProduitChange()" class="org-radio-input" [disabled]="savingPrixAchatOpts || loadingSettings">
                        <label class="org-radio-label" for="majPrixAchatNon"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" style="margin-left: 9px; cursor: pointer" for="majPrixAchatNon">Non</label>
                </div>
            </div>
        </div>
    </div>

    <!-- Base de calcul du prix d'achat (CMUP facture fournisseur) -->
    <div class="row mb-1">
        <div class="d-flex flex-column gap-2">
            <label class="mb-0 size15">Fixer la base de calcul du prix d'achat</label>
            <div class="d-flex flex-column gap-2" style="margin-top: 8px;">
                <div class="d-flex align-items-center gap-2">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="baseCalculPrixAchat" id="baseCalculProduit" [value]="'produit'" [(ngModel)]="selectedBaseCalculPrixAchat" (ngModelChange)="onBaseCalculPrixAchatChange()" class="org-radio-input" [disabled]="savingPrixAchatOpts || loadingSettings">
                        <label class="org-radio-label" for="baseCalculProduit"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" style="margin-left: 9px; cursor: pointer" for="baseCalculProduit">Prix d'achat enregistré sur le produit</label>
                </div>
                <div class="d-flex align-items-center gap-2" style="margin-top: 8px">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="baseCalculPrixAchat" id="baseCalculDocument" [value]="'document_achat'" [(ngModel)]="selectedBaseCalculPrixAchat" (ngModelChange)="onBaseCalculPrixAchatChange()" class="org-radio-input" [disabled]="savingPrixAchatOpts || loadingSettings">
                        <label class="org-radio-label" for="baseCalculDocument"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" style="margin-left: 9px; cursor: pointer" for="baseCalculDocument">Prix d'achat sur le document d'achat</label>
                </div>
            </div>
        </div>
    </div>

    <!-- Affichage lignes produit -->
    <div class="row mb-2">
        <div class="col-12 pl-0">
            <dd class="mb-1"><b>Affichage des lignes produit sur les documents</b></dd>
            <div class="custom-control custom-checkbox">
                <input
                    type="checkbox"
                    class="custom-control-input"
                    id="affProduitMatriciel"
                    [(ngModel)]="affProduitMatriciel"
                    (ngModelChange)="onAffProduitMatricielChange()"
                    [disabled]="savingAffProduitMatriciel || loadingSettings"
                />
                <label class="custom-control-label size15" for="affProduitMatriciel">
                    Forme matricielle (couleur × taille)
                </label>
            </div>
            <p class="size13 text-muted mb-0 pl-1">
                Décoché : affichage classique, une ligne par variante.
            </p>
        </div>
    </div>

    <!-- Cachet sur document -->
    <div class="row mb-1">
        <div class="">
            <label class="size15">Afficher un cachet sur les documents</label>

            <div
                    class="card card-document-input text-center p-3"
                    (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)"
                    [class.drag-active]="isDragging"
            >
                <!-- Icône -->
                <label for="fileInput" class="cursor-pointer d-block mb-2">
                    <button class="unstyled-btn">
                        <i data-feather="upload" [size]="18"></i>
                    </button>

                </label>

                <!-- Input file caché -->
                <input
                        #fileInputCachet
                        id="fileInput"
                        type="file"
                        accept="image/*,.pdf"
                        (change)="onFileSelected($event)"
                        hidden
                />
                <dd *ngIf="!fileUrl" style="font-size: 16px; color: #2F2B3DE5">Déposez votre image ici <br></dd>
                <span style="text-align: center">ou</span>
                <!-- Message ou aperçu -->
                <button type="button" class="ml-3 unstyled-btn2" (click)="triggerFileInput(fileInputCachet)">
                    Parcouriez votre image
                </button>


                <img
                        *ngIf="fileUrl && isImage"
                        [src]="fileUrl"
                        alt="Aperçu du fichier"
                        class="img-fluid mt-2"
                />

                <iframe
                        *ngIf="fileUrl && isPdf"
                        [src]="fileUrl"
                        width="100%"
                        height="200px"
                        class="mt-2"
                ></iframe>
            </div>
        </div>
    </div>


    <!-- Référence du document (modèles chargés depuis l'API) -->
    <dd><b>Référence du document</b></dd>
    <div class="row mb-1" *ngIf="loadingReferenceModels">
        <div class="col-12 p-2">
            <span class="spinner-border spinner-border-sm" role="status"></span> Chargement des modèles...
        </div>
    </div>
    <div class="row mb-1" *ngIf="!loadingReferenceModels && referenceModels.length > 0">
        <div *ngFor="let model of referenceModels; let i = index"
             class="p-2 col-lg-2 col-xl-2 card-model mt-2 mb-2"

             [class.mr-4]="i >= 0 && i < referenceModels.length - 1"
             [class.card-selected]="isReferenceModelSelected(model)"
             (click)="selectedRefModelId = model.id; onReferenceModelChange()"
             [class.pe-none]="savingReferenceModel || loadingSettings">
            <p class="size15" style="color: #2F2B3DE5">{{ getReferenceTitle(model) }}</p>
            <span class="size13">{{ getReferenceFormat(model) }}</span><br/>
            <div class="org-radio-wrapper">
                <input type="radio" name="refDocModel" [id]="'ref-' + model.id" [value]="model.id" [(ngModel)]="selectedRefModelId" (change)="onReferenceModelChange()" class="org-radio-input" [disabled]="savingReferenceModel || loadingSettings">
                <label class="org-radio-label" [attr.for]="'ref-' + model.id"><span class="org-radio-dot"></span></label>
            </div>
        </div>
    </div>
    <div class="row mb-1" *ngIf="!loadingReferenceModels && referenceModels.length === 0">
        <div class="col-12 p-2 text-muted">Aucun modèle de référence disponible.</div>
    </div>

    <!-- Paramétrage -->
    <dd class="mb-1 "><b>Paramétrage des documents</b></dd>
    <div class="row mb-5 justify-content-start">
        <div class="col-lg-5 card-modelBig p-2 mr-2" [class.card-selected]="selectedDocType === 'achat'" (click)="selectDocTypeAndGo('achat')">
            <div class="d-flex justify-content-center mb-2">
                <i data-feather="shopping-cart" [size]="30"></i>
            </div>
            <span style="font-size: 18px;">Achat</span>
            <p>Paramétrer les documents d’achat</p>
            <div class="org-radio-wrapper ">
                <input type="radio" name="type" id="typeAchat" value="achat" [(ngModel)]="selectedDocType" (change)="goToDocumentAchat()" class="org-radio-input">
                <label class="org-radio-label" for="typeAchat"><span class="org-radio-dot"></span></label>
            </div>
        </div>

        <div class="col-lg-5 card-modelBig p-2" [class.card-selected]="selectedDocType === 'vente'" (click)="selectDocTypeAndGo('vente')">
            <div class="d-flex justify-content-center mb-2">
                <i data-feather="dollar-sign" [size]="30"></i>
            </div>
            <span style="font-size: 18px;">Vente</span>
            <p>Paramétrer les documents de vente</p>
            <div class="org-radio-wrapper ">
                <input type="radio" name="type" id="typeVente" value="vente" [(ngModel)]="selectedDocType" (change)="goToDocumentVente()" class="org-radio-input">
                <label class="org-radio-label" for="typeVente"><span class="org-radio-dot"></span></label>
            </div>
        </div>
    </div>

    <div class="row mb-4 mt-2">
        <div class="col-12 justify-content-end">
            <button
                    type="button"
                    class="btn btn-primary waves-effect"
                    (click)="saveParametreDocument()"
                    [disabled]="saving || loadingSettings || stationId === 0">
                {{  'Enregistrer' }}
            </button>
        </div>
    </div>
</div>
